import React from "react"
import { useDiensten } from "../../../hooks/useDiensten"
import { Link } from "gatsby"
import Container from "../../atoms/Container"
import "./DienstenOverzicht.css"
import ChevronRight from "../../atoms/Icons/ChevronRight"

export default function DienstenOverzicht({ block, view, current }) {
  const data = useDiensten()

  if (view == "grid") {
    return (
      <Container styles={`${view == "grid" ? "" : "vt-diensten-list"}`}>
        <div className="vt-diensten-overzicht">
          <h2>{block.titel ? block.titel : block.title}</h2>
          <div
            className={`${
              view == "grid"
                ? "vt-diensten-overzicht-grid"
                : "vt-diensten-overzicht-list"
            }`}
          >
            {data.allWpDienst.edges.map(dienst => {
              if (current !== dienst.node.id) {
                return (
                  <Link to={dienst.node.uri}>
                    <div className="vt-dienst-container">
                      <div className="vt-dienst-container-content">
                        <img
                          src={dienst.node.diensten.icon.localFile.publicURL}
                        />
                        <div>
                          <h3>{dienst.node.title}</h3>
                        </div>
                      </div>
                      <ChevronRight className="vt-dienst-chevron" />
                    </div>
                  </Link>
                )
              }
            })}
          </div>
          <div className="vt-whitespace-container"></div>
        </div>
      </Container>
    )
  } else {
    return (
      <div className="vt-diensten-list">
        <div className="vt-diensten-overzicht">
          <h2>{block.titel ? block.titel : block.title}</h2>
          <div
            className={`${
              view == "grid"
                ? "vt-diensten-overzicht-grid"
                : "vt-diensten-overzicht-list"
            }`}
          >
            {data.allWpDienst.edges.map(dienst => {
              if (current !== dienst.node.id) {
                return (
                  <Link to={dienst.node.uri}>
                    <div className="vt-dienst-container">
                      <div className="vt-dienst-container-content">
                        <img
                          src={dienst.node.diensten.icon.localFile.publicURL}
                        />
                        <div>
                          <h3>{dienst.node.title}</h3>
                        </div>
                      </div>
                      <ChevronRight className="vt-dienst-chevron" />
                    </div>
                  </Link>
                )
              }
            })}
          </div>
          <div className="vt-whitespace-container"></div>
        </div>
      </div>
    )
  }
}
